// extracted by mini-css-extract-plugin
module.exports = {"rpSpinner":"ResortPassAnimation_rpSpinner__7btM_","lottie":"ResortPassAnimation_lottie__ocNl_"};